<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Mail Box" pageTitle="Mail Box" />
            <InboxContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import InboxContent from '../Inbox/InboxContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'InboxBoxPage',
    components: {
        MainHeader,
        PageTitle,
        InboxContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>